import type { BaseKeyFunction } from "../../../lib";

export type KeyExistsProps = { email: string };

export const keyExists: BaseKeyFunction<KeyExistsProps> = ({ email }) => [
  "exists",
  email,
];
